import React, { useContext } from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { store as mainStore } from '../../../../../store';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
}));

const Welcome = () => {
  const {
    state: {
      Auth: { profile },
    },
  } = useContext(mainStore);
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      کارشناس حمل گرامی،{' '}
      <b>
        <Link to={`/protected/admin/password`}>{`${
          profile?.firstName + ' ' || ''
        }${profile?.lastName || ''} `}</Link>
      </b>
      خوش آمدید.
    </Paper>
  );
};

export default React.memo(Welcome);
